import { OrderStatusConfigStore, DEFAULT_STATUSES } from "@infrastructure/stores/orderStatusConfig.store";
import { apiClients } from "@infrastructure/clients";
import { catchError } from "@shared/utils/errors/catchError";

class OrderStatusConfigServiceClass {
  private _loaded = false;
  private _loadPromise: Promise<void> | null = null;

  getStore() {
    return OrderStatusConfigStore;
  }

  async loadStatuses(): Promise<void> {
    if (this._loaded) return;
    if (this._loadPromise) return this._loadPromise;

    this._loadPromise = this._fetch();
    await this._loadPromise;
    this._loadPromise = null;
  }

  private async _fetch(): Promise<void> {
    const [error, result] = await catchError(
      apiClients.http.order.getOrderStatusConfig()
    );
    if (error) {
      console.error("[OrderStatusConfigService] Failed to load statuses:", error);
      OrderStatusConfigStore.setStatuses(DEFAULT_STATUSES);
      return;
    }
    OrderStatusConfigStore.setStatuses(result.data);
    this._loaded = true;
  }
}

export const OrderStatusConfigService = new OrderStatusConfigServiceClass();
